import { DictionaryContextType } from '../dictionaries/context/DictionaryContextTypes';
import { BankType, BrandType, NegotiationOption, OutDebt, OutDebtFieldsFragment } from '../generated/graphql';
import thousandSeparator from './thousandSeparator';

type ContentInstallmentsPlanBbvaType = {
  gT: (key: string, context?: DictionaryContextType) => string,
  outDebt: OutDebt,
  negOption?: NegotiationOption,
  outDebts?: Array<OutDebtFieldsFragment>
};

enum Normative026RawKeys {
  Relief = 'alivio',
  Modified = 'modificado',
  Reestructured = 'reestructurado',
}

enum BbvaInstallmentsPlanKeys {
  SendToBank = 'negotiation_InstallmentsPlan_confirmation_description_SENT_TO_BANK',
  ConfirmByUser = 'negotiation_InstallmentsPlan_confirmation_description_CONFIRMED_BY_USER',
  ApprovedByBank = 'negotiation_InstallmentsPlan_confirmation_description_APPROVED_BY_BANK',
  RejectedByBank = 'negotiation_InstallmentsPlan_confirmation_description_REJECTED_BY_BANK',
  Relief = 'negotiation_InstallmentsPlan_consequences_relief',
  Modified = 'negotiation_InstallmentsPlan_consequences_modified',
  Reestructured = 'negotiation_InstallmentsPlan_consequences_reestructured',
  Multidebt = 'negotiation_InstallmentsPlan_consequences_multidebt',
}

const getSharedContent = (props : ContentInstallmentsPlanBbvaType) => {
  const { gT, outDebt, outDebts } = props;
  const normative026 = outDebt?.extra?.normative026Raw?.toLowerCase();
  const keys = [];
  if (normative026?.includes(Normative026RawKeys.Relief)) {
    keys.push(gT(BbvaInstallmentsPlanKeys.Relief));
  }
  if (normative026?.includes(Normative026RawKeys.Reestructured)) {
    keys.push(gT(BbvaInstallmentsPlanKeys.Reestructured));
  }
  if (normative026?.includes(Normative026RawKeys.Modified)) {
    keys.push(gT(BbvaInstallmentsPlanKeys.Modified));
  }

  if (outDebts && outDebts.filter(
    ({ bank, brand }) => bank === BankType.Bbva && brand === BrandType.Tranquiapp,
  ).length > 1) {
    keys.push(gT(BbvaInstallmentsPlanKeys.Multidebt));
  }

  return keys;
};

export const getBbvaSendToBankContentText = (props : ContentInstallmentsPlanBbvaType) => {
  const { gT } = props;
  const keys = [ gT(BbvaInstallmentsPlanKeys.SendToBank) ];
  const result = keys.concat(getSharedContent(props));

  return result.join('\n');
};

export const getBbvaConfirmByUserContentText = (props : ContentInstallmentsPlanBbvaType) => {
  const { gT } = props;
  const keys = [ gT(BbvaInstallmentsPlanKeys.ConfirmByUser) ];
  const result = keys.concat(getSharedContent(props));

  return result.join('\n');
};

export const getBbvaApprovedByBankContentText = (props : ContentInstallmentsPlanBbvaType) => {
  const { gT, outDebt } = props;
  const keys = [
    gT(BbvaInstallmentsPlanKeys.ApprovedByBank),
  ];
  const normative026 = outDebt?.extra?.normative026Raw?.toLowerCase();
  if (normative026?.includes(Normative026RawKeys.Reestructured)) {
    keys.push(gT(BbvaInstallmentsPlanKeys.Reestructured));
  }
  if (normative026?.includes(Normative026RawKeys.Modified)) {
    keys.push(gT(BbvaInstallmentsPlanKeys.Modified));
  }

  return keys.join('\n');
};

export const getBbvaRejectedByBankContentText = (props : ContentInstallmentsPlanBbvaType) => {
  const { gT, outDebt } = props;
  return gT(BbvaInstallmentsPlanKeys.RejectedByBank, { productNumber: `${outDebt.productNumber}`, minPayment: `${thousandSeparator(outDebt.minPayment)}` });
};
